import DataTable from "@standard/components/DataTable";
import TitleHeader from "@standard/components/TitleHeader";
import CustomerForm from "./CustomerForm";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import PriceRateForm from "./PriceRateForm";

const programType = "Master";
const programName = "Customer Setup";
const url = "master/customer";
const columns = [
  {
    label: "Alias",
    name: "alias",
    align: "center",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Customer Name",
    name: "name",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Tax No.",
    name: "taxNo",
    sortable: true,
    search: { type: "text" },
  },
];

const config = {
  enableActive: true,
  enableEdit: true,
  enableTrash: true,
};

export default function Customer() {
  const { path } = useRouteMatch();

  return (
    <>
      <TitleHeader programName={programName} programType={programType} />
      <Switch>
        <Route exact path={path}>
          <DataTable columns={columns} url={url} {...config} />
        </Route>
        <Route path={`${path}/pricerate/:id/:wheel`}>
          <PriceRateForm />
        </Route>
        <Route path={`${path}/:action/:id?`}>
          <CustomerForm url={url} />
        </Route>
      </Switch>
    </>
  );
}
